
const testimonyData = [
    {
        id: 1,
        name: 'Harsh Arora',
        testimony : 'Seamless online consultations, expert care - a game-changer for medical accessibility and convenience!',
        image : 't2',
    },
    {
        id: 2,
        name: 'Lakshay Dhall',
        testimony : 'Reliable doctors, hassle-free appointments - this app revolutionized my online doctor consultations',
        image : 't1',
    },
    {
        id: 3,
        name: 'Vansh Gaba',
        testimony : 'From home or anywhere, quality healthcare - this web app delivers timely medical expertise.',
        image : 't3',
    },
    
];

const services = [
    {
        id: 1,
        title: 'Virtual Consultations',
        details: 'Connect with experienced doctors through chats for real-time medical advice and diagnoses.',
        image : 'virtual-chat',
    },
    {
        id: 2,
        title: '24/7 Access',
        details: 'Get access to our services anytime, anywhere, allowing you to seek medical help whenever you need it.',
        image : '24-7',
    },
    {
        id: 3,
        title: 'Expert Specialists',
        details: 'Consult with qualified doctors specialized in various fields to address specific health concerns.',
        image : 'expert',
    },
    
];

const howItWorks = [
    {
        id: 1,
        title: 'Find Doctor',
        details: 'Discover top-rated doctors with a quick search on the app.',
        image : 'doctor',
    },
    {
        id: 2,
        title: 'Check Doctor Profile',
        details: 'Explore doctors profiles for their specialization and expertise.',
        image : 'doctorProfile',
    },
    {
        id: 3,
        title: 'Start Consultation',
        details: 'Engage in an online consultation with trusted healthcare experts.',
        image : 'schedule',
    },{
        id: 4,
        title: 'Get Solutions',
        details: 'Receive expert advice and solutions to your health issues online.',
        image : 'solutions',
    },
    
];



export {testimonyData,services,howItWorks};